import React, { useState } from 'react';
import { HelpCircle, Book, MessageCircle, Star, PlayCircle } from 'lucide-react';
import Documentation from './help/Documentation';
import Support from './help/Support';
import Testimonials from './help/Testimonials';
import VideoTutorials from './help/VideoTutorials';

export default function Help() {
  const [activeSection, setActiveSection] = useState<string | null>(null);

  const renderContent = () => {
    switch (activeSection) {
      case 'documentation':
        return <Documentation />;
      case 'support':
        return <Support />;
      case 'testimonials':
        return <Testimonials />;
      case 'tutorials':
        return <VideoTutorials onNavigateToSupport={() => setActiveSection('support')} />;
      default:
        return (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Documentation */}
            <div
              onClick={() => setActiveSection('documentation')}
              className="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <Book className="h-8 w-8 text-indigo-600 dark:text-indigo-400 mb-4" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Documentação
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Acesse nossos guias e tutoriais detalhados sobre como usar a plataforma.
              </p>
            </div>

            {/* Support */}
            <div
              onClick={() => setActiveSection('support')}
              className="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <MessageCircle className="h-8 w-8 text-indigo-600 dark:text-indigo-400 mb-4" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Suporte
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Entre em contato com nossa equipe de suporte para resolver suas dúvidas.
              </p>
            </div>

            {/* Testimonials */}
            <div
              onClick={() => setActiveSection('testimonials')}
              className="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <Star className="h-8 w-8 text-indigo-600 dark:text-indigo-400 mb-4" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Depoimentos
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Descubra como outros criadores alcançaram o sucesso com NovaContent e inspire-se com suas histórias.
              </p>
            </div>

            {/* Video Tutorials */}
            <div
              onClick={() => setActiveSection('tutorials')}
              className="p-6 bg-gray-50 dark:bg-gray-800 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
            >
              <PlayCircle className="h-8 w-8 text-indigo-600 dark:text-indigo-400 mb-4" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Vídeos Tutoriais
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Aprenda a usar a plataforma com nossos vídeos explicativos.
              </p>
            </div>
          </div>
        );
    }
  };

  return (
    <div className="space-y-8">
      <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-sm">
        <div className="flex items-center space-x-4 mb-6">
          <div className="w-12 h-12 rounded-lg bg-indigo-100 dark:bg-indigo-900/50 flex items-center justify-center">
            <HelpCircle className="h-6 w-6 text-indigo-600 dark:text-indigo-400" />
          </div>
          <div>
            <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
              Central de Ajuda
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Encontre respostas para suas dúvidas
            </p>
          </div>
        </div>

        {activeSection && (
          <button
            onClick={() => setActiveSection(null)}
            className="mb-6 text-indigo-600 dark:text-indigo-400 hover:text-indigo-700 dark:hover:text-indigo-300"
          >
            ← Voltar
          </button>
        )}

        {renderContent()}
      </div>
    </div>
  );
}